import { z } from 'zod';
import type {
  InternalBookingsSortBy,
  MaintenancePlansSortBy,
} from 'src/apis/capacity-management/types';
import {
  descSortDirectionSchema,
  getPaginationSchema,
} from 'src/components/form/zod-schemas';
import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';

const internalBookingsSchema = z.object({
  sortBy: z
    .enum(['validFrom'] satisfies InternalBookingsSortBy[])
    .default('validFrom'),
  sortDirection: descSortDirectionSchema,
  ...getPaginationSchema().shape,
});

const maintenancePlansSchema = z.object({
  sortBy: z
    .enum([
      'validFrom',
      'validTo',
      'planned',
    ] satisfies MaintenancePlansSortBy[])
    .default('validFrom'),
  sortDirection: descSortDirectionSchema,
  ...getPaginationSchema().shape,
});

export function usePageParams() {
  const internalBookings = usePageParamsFromSchema(internalBookingsSchema, {
    groupPrefix: 'internalBookings',
  });

  const maintenancePlans = usePageParamsFromSchema(maintenancePlansSchema, {
    groupPrefix: 'maintenancePlans',
  });

  return {
    internalBookings,
    maintenancePlans,
  };
}

export type PageParams = ReturnType<typeof usePageParams>;
